import './index.less';
import * as React from 'react';
import { Button, Dropdown, Menu, Divider, Spin, notification, } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { inject, observer } from 'mobx-react';
import Stores from '../../stores/storeIdentifier';
import Dashboard from './components/dashboard';
import TimeClock from './components/timeClock';
import CalendarForm from './components/calendarForm';
import Options from './components/options';
import { L, isGranted } from '../../lib/abpUtility';
import { ApiTwoTone, AppstoreTwoTone, AuditOutlined, CalendarOutlined, CommentOutlined, DashboardOutlined, DeploymentUnitOutlined, FileTextTwoTone, FolderOpenOutlined, GroupOutlined, HistoryOutlined, IdcardOutlined, IdcardTwoTone, LoadingOutlined, LockTwoTone, LogoutOutlined, RightCircleTwoTone, SearchOutlined, SettingOutlined, ShopOutlined, ShoppingCartOutlined, ShoppingOutlined, TeamOutlined, UpCircleOutlined } from '@ant-design/icons';
import DashboardFilterDrawer from '../Controls/Drawers/Custom/dashboardFilterDrawer';
import DashboardHelp from '../Controls/Help/dashboardHelp';
import SignOutDrawer from '../Controls/Drawers/Custom/signOutDrawer';
import ModuleChooser from '../Controls/Forms/Custom/moduleChooser';
import { itemTypes } from '../EntityConfigs/itemTypes';
import CommunicationStore from '../../stores/communicationStore';
import IntegrationStore from '../../stores/integrationStore';
import InventoryStore from '../../stores/inventoryStore';
import MenuStore from '../../stores/menuStore';
import PaymentsStore from '../../stores/paymentStore';
import PeopleStore from '../../stores/peopleStore';
import ReportStore from '../../stores/reportStore';
import RoleStore from '../../stores/roleStore';
import SchedulingStore from '../../stores/schedulingStore';
import TeamStore from '../../stores/teamStore';
import WorkOrderStore from '../../stores/workOrderStore';
import { FormInstance } from 'antd/lib/form';
import { RelatedEntityTypes } from '../EntityConfigs/relatedEntityTypes';
import TemplateChooser from '../Controls/Forms/Custom/templateChooser';
import { NoteSummaryDto } from '../../services/dto/summaries/noteSummaryDto';
import UserStore from '../../stores/userStore';
import { RcFile } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import { NoteTypes } from '../EntityConfigs/noteTypes';

//import CondoLogo from './../../images/ftb/icon.png';

import CondoLogo from './../../images/swi/logoIcon.png';
import { appRouters } from '../Router/router.config';


export interface IHeaderProps {
  hasCreatePermissions: boolean;
  hasWidgetPermissions: boolean;
  history: any;

  headerLoading: boolean;
  collapsed?: any;
  isMobile: boolean;

  location: any;
  primaryColor: string;
  secondaryColor: string;
  dataTableImage: string;

  communicationStore: CommunicationStore;
  inventoryStore: InventoryStore;
  menuStore: MenuStore;
  paymentStore: PaymentsStore;
  peopleStore: PeopleStore;
  reportStore: ReportStore;
  roleStore: RoleStore;
  schedulingStore: SchedulingStore;
  teamStore: TeamStore;
  workOrderStore: WorkOrderStore;
  integrationStore: IntegrationStore;
  userStore: UserStore;

  userID: number;
  currentRoles: string[];
  profileImageURL: string;
  profileID: number;
  tenantName: string;
  username: any;
  currentName: any;
  currentLoginName: string;

  userFirstName: any;
  userLastName: any;
  userEmail: any;

  subscriptionType: any;
  subscriptionStart: any;
  subscriptionEnd: any;
  availableTemplates: any;  


}

export interface IHeaderState {
  availableItemsList: string[];
  availableUsersList: string[];

  timeClock_drawerVisible: boolean;
  signOut_drawerVisible: boolean;
  entity_modalVisible: boolean;
  createItem_modalVisible: boolean;
  dashboard_drawerVisible: boolean;
  dashboardFilter_drawerVisible: boolean;
  templateChooser_modalVisible: boolean;
  dashboardHelp_drawerVisible: boolean;
  calendar_modalVisible: boolean;
  options_drawerVisible: boolean;
  loading: boolean;
  entityId: any;
  defaultProfileImage: string;
  softMenu: boolean; 
  entityTemplate_name: string;
  entityTemplateId: any;
  moduleType: any;
  currentProfileImage: string;
  currentSteps: Array<any>;
  currentFileList: Array<any>;
  commentsFilterValue: any;
  commentsLoading: boolean;
  fileListLoading: boolean;
  defaultCommentsList: any[];
  currentState: any;
  filesLoading: boolean;
  lastModifiedClean: any;

  enableCreate: boolean;
  enableActivity: boolean;
  enableCalendar: boolean;
  enableFiles: boolean;
  enableOptions: boolean;
  enableSearch: boolean;
  enableSignOut: boolean;
  enableNavigate: boolean;
  iconFontSize: any; 
}

@inject(
  Stores.UserStore,
  Stores.SessionStore,
  Stores.CommunicationStore,
  Stores.InventoryStore,
  Stores.MenuStore,
  Stores.PaymentStore,
  Stores.PeopleStore,
  Stores.ReportStore,
  Stores.RoleStore,
  Stores.SchedulingStore,
  Stores.TeamStore,
  Stores.WorkOrderStore,
  Stores.IntegrationStore)
@observer
class Header extends React.Component<IHeaderProps, IHeaderState> {

  entity_FormRef = React.createRef<FormInstance>();
  entityFields_FormRef = React.createRef<FormInstance>();
  userEdit_FormRef = React.createRef<FormInstance>();

  state = {
    availableItemsList: [],
    availableUsersList: [],
    defaultCommentsList: [],
    lastModifiedClean: '',
    currentState: 0,
    filesLoading: false,
    fileListLoading: false,
    commentsFilterValue: NoteTypes.ActionItem,
    commentsLoading: false,
    moduleType: 0,
    currentSteps: [],
    entity_modalVisible: false,
    entityTemplate_name: '',
    signOut_drawerVisible: false, 
    dashboardHelp_drawerVisible: false,
    dashboardFilter_drawerVisible: false,
    createItem_modalVisible: false,
    templateChooser_modalVisible: false,
    contact_drawerVisible: false,
    timeClock_drawerVisible: false,
    dashboard_drawerVisible: false,
    entityTemplateId: 0,
    calendar_modalVisible: false,
    entityId: 0,
    currentFileList: [],
    options_drawerVisible: false,
    loading: false,
    defaultProfileImage: '',
    softMenu: false,
    currentProfileImage: '',
    iconFontSize: '1.1em',


    enableCreate: true,
    enableActivity: true,
    enableCalendar: true,
    enableFiles: true,
    enableOptions: true,
    enableSearch: true,
    enableSignOut: true,
    enableNavigate: true,

  };

  async componentDidMount() {

  
 
    window.addEventListener('scroll', this.handleScroll)
    //await this.props.userStore.initFileStores();
    //await this.props.userStore.initUpdateObject();
    //await this.props.userStore.getAll({ maxResultCount: 100, skipCount: 0, keyword: '' });
    //this.setUsersList();


  }

  handleScroll = () => {
    const position = window.pageYOffset;
    if (position >= 50) {
      this.setState({ softMenu: true });
    }
    else {
      this.setState({ softMenu: false });
    }
  };

  
  //----------------------------------------

  async createItem_OpenDrawer() {
    this.setState({
      createItem_modalVisible: !this.state.createItem_modalVisible,
      moduleType: 0
    });
  };

  tempalateChooser_Modal = () => {
    this.setState({
      templateChooser_modalVisible: !this.state.templateChooser_modalVisible,
    });
  };

  createItem_CloseDrawer = () => {
    this.setState({
      createItem_modalVisible: !this.state.createItem_modalVisible,

    });
  };

  createItem_handleUpdate = (values: any) => {

    this.createItem_CloseDrawer();
    this.setState({ moduleType: values });
    this.tempalateChooser_Modal();

  };


  entity_Modal = () => {
    this.setState({
      entity_modalVisible: !this.state.entity_modalVisible,
    });
  };

  templateSelect_handleCancel = () => {
    this.setState({
      templateChooser_modalVisible: false,
      entity_modalVisible: false,
      defaultProfileImage: '',
      entityId: 0,
      entityTemplateId: 0
    })


  };

  getCurrentStore() {

    if (this.state.moduleType === itemTypes.Communication) {
      return this.props.communicationStore;
    }
    else if (this.state.moduleType === itemTypes.Integrations) {
      return this.props.integrationStore;
    }
    else if (this.state.moduleType === itemTypes.Inventory) {
      return this.props.inventoryStore;
    }
    else if (this.state.moduleType === itemTypes.Menu) {
      return this.props.menuStore;
    }
    else if (this.state.moduleType === itemTypes.Payments) {
      return this.props.paymentStore;
    }
    else if (this.state.moduleType === itemTypes.Persons) {
      return this.props.peopleStore;
    }
    else if (this.state.moduleType === itemTypes.Reports) {
      return this.props.reportStore;
    }
    else if (this.state.moduleType === itemTypes.Schedules) {
      return this.props.schedulingStore;
    }
    else if (this.state.moduleType === itemTypes.Teams) {
      return this.props.teamStore;
    }
    else if (this.state.moduleType === itemTypes.WorkOrders) {
      return this.props.workOrderStore;
    }
    else { return this.props.peopleStore }
  };

  async entity_create(id: any) {

    var entityStore = this.getCurrentStore();
    entityStore.initFileStores();
    entityStore.initCacheStores();

    //Init Update Object
    entityStore.initUpdateObject(
      RelatedEntityTypes.Entity,
      this.state.moduleType,
      0, 100
    );

    if (id !== 0) {

      this.setState({ loading: true })

      const self = this;
      self.setState({ entityId: 0, entityTemplateId: id, templateChooser_modalVisible: false });
      self.entity_Modal();

      await entityStore.getType({ id: id });
      this.setState({ entityTemplate_name: entityStore.entityReturn.types[0].name })

      entityStore.defaultValues = entityStore.entityReturn.types[0].relatedItemsVerbose.map((x: any) => {

        let returnString =
        {
          gridType: 0,
          loading: false,
          formItems: [{
            itemType: x.itemType,
            selectionType: x.selectionType,
            fieldName: x.name,
            disabled: false,
            defaultKey: x.name,
            primaryColor: this.props.primaryColor,
            secondaryColor: this.props.secondaryColor,
            dataTableText: '',
            dataTableImage: '',
            optionsList: x.relatedOptionsVerbose.map((y: any) => {
              return {
                value: y.id,
                text: y.title
              }
            })
            ,
            dataSource: [],
            inputType: x.inputType,
            number: 0,
            entityStore: entityStore,
            text: '',
            defaultValues: [],
            defaultChecked: false,
            pacelHolderChecked: false,
            pacelHolderUnChecked: false,
            placeHolder: '',
            defaultImage: '',
            defaultKeys: [],
            imageUrl: '',
            imageLoaderUrl: '',
            intialFilesList: [],
            defaultFiles: [],

            onChange: () => '',
            removeOption: () => '',
          }]
        };

        return returnString;
      });



      this.setState({ currentSteps: entityStore.entityReturn.types[0].relatedStatesVerbose });

      this.setState({ loading: false })
    }
    else {
      notification.open({
        message: L('Error'),
        description:
          L('Unable to open Entity')
      });
    }
  }

  createItem_handleCancel = () => {
    this.createItem_CloseDrawer();
  };


  entity_handleCreate = (values: any) => {

    var entityStore = this.getCurrentStore();

    //Init Update Object
    entityStore.initUpdateObject(
      RelatedEntityTypes.Entity,
      this.state.moduleType,
      0, 100
    );

    //Create Item 
    var updateObject: any;
    updateObject = {
      id: this.state.entityId,
      ...values
    }

    //Add Object to Store
    entityStore.entityCreate.entities.push(updateObject);

    if (this.state.entityId === 0) {

      //Create via Store
      entityStore.createEntity();

      notification.open({
        message: L('Confirmation'),
        description:
          L('Entity Successfully Created')
      });

      //entityStore.getEntitySummary('');
    }
    else {
      notification.open({
        message: L('Error'),
        description:
          L('Unable to Create Existing Entity')
      });
    }

    this.setState({
      entity_modalVisible: false,
      defaultProfileImage: '',
      currentSteps: []
    });
  };

  entity_handleCancel = () => {
    this.setState({
      entity_modalVisible: false,
      defaultProfileImage: '',
      entityId: 0,
      currentSteps: []
    })

    this.getCurrentStore().initFileStores();
  };

  //------------------------------------------------------------

  async calendar_OpenDrawer() {
    this.setState({
      calendar_modalVisible: !this.state.calendar_modalVisible,
    });
  };

  calendar_CloseDrawer = () => {
    this.setState({
      calendar_modalVisible: !this.state.calendar_modalVisible,

    });
  };

  calendar_handleUpdate = (values: any) => {
    this.calendar_CloseDrawer();
  };

  calendar_handleCancel = () => {
    this.calendar_CloseDrawer();
  };

  //------------------------------------------------------------

  async timeClock_OpenDrawer() {
    this.setState({
      timeClock_drawerVisible: !this.state.timeClock_drawerVisible,
    });
  };

  timeClock_CloseDrawer = () => {
    this.setState({
      timeClock_drawerVisible: !this.state.timeClock_drawerVisible,

    });
  };

  timeClock_handleUpdate = (values: any) => {
    this.timeClock_CloseDrawer();
  };

  timeClock_handleCancel = () => {
    this.timeClock_CloseDrawer();
  };

  //------------------------------------------------------------

  dashboard_OpenDrawer = async () => {
    this.setState({
      dashboard_drawerVisible: !this.state.dashboard_drawerVisible,
    });


    await this.props.userStore.initUpdateObject();
    this.props.userStore.initFileStores();

    this.setState({ filesLoading: true });

    if (this.state.commentsLoading == false) {

      if (this.props.userID !== 0) {

        this.setState({ commentsLoading: true });
        await this.props.userStore.getNotes(this.props.userID)

        this.props.userStore.entityNotesSummary.items = [];
        this.props.userStore.entityReturn.notes.map((x: any) => {

          this.props.userStore.defaultEntityNotes.push(x);
          this.props.userStore.entityNotesCache.push(x);
          this.props.userStore.entityNotesSummary.totalCount = this.props.userStore.entityNotesSummary.totalCount + 1;

          //let url =  this.props.userStore.getCommentImage({ id: x.creatorID }); profileImageURL: url
          this.props.userStore.entityNotesSummary.items.push({ ...x, });

          this.setState({ defaultCommentsList: [] });
          let commentValues = this.props.userStore.entityNotesSummary.items;
          this.setState({ defaultCommentsList: commentValues });


        })

      }
      else {
        notification.open({
          message: L('Error'),
          description:
            L('Unable to fetch Activity')
        });
      }
    }


    //await this.props.userStore.getFiles(this.props.userID);
    this.setState({ currentFileList: this.props.userStore.defaultEntityFiles, filesLoading: false, commentsLoading: false })

  };

  async dashboard_CloseDrawer() {
    this.setState({
      dashboard_drawerVisible: !this.state.dashboard_drawerVisible,

    });
  };

  dashboard_handleUpdate = (values: any) => {
    this.dashboard_CloseDrawer();
    this.props.userStore.syncNotes(this.props.userID);
    this.props.userStore.initUpdateObject();

  };

  dashboard_handleCancel = async () => {
    this.dashboard_CloseDrawer();
    await this.props.userStore.syncNotes(this.props.userID);

    this.props.userStore.initUpdateObject();
  };

  //------------------------------------------------------------ 

  async options_OpenDrawer() {

    this.setState({
      options_drawerVisible: !this.state.options_drawerVisible, loading: true
    });

    if (this.props.profileID !== 0) {
      let returnURL = await this.props.userStore.getProfileImage(this.props.profileID);
      this.setState({ defaultProfileImage: returnURL });
    }
    this.setState({ loading: false });
  };

  options_CloseDrawer = () => {
    this.setState({
      options_drawerVisible: !this.state.options_drawerVisible,

    });
  };

  options_handleUpdate = (values: any) => {
    this.options_CloseDrawer();
  };

  options_handleCancel = () => {
    this.options_CloseDrawer();
  };

  options_uploadImage = () => {
    // this.options_CloseDrawer();
  };


  //-----------------------------------------------------------------

  async commentAdd(noteCreate: NoteSummaryDto) {
    this.setState({ commentsLoading: true });
    this.setState({ commentsLoading: true });
    await this.props.userStore.addNote({ ...noteCreate, currentUserImageID: this.props.profileID });
    await this.commentFilter(this.state.commentsFilterValue);
    this.setState({ commentsLoading: false });
  }

  async commentImageSync() {

    this.props.userStore.entityNotesSummary.items = [];
    let noteCount = this.props.userStore.entityReturn.notes.length;

    this.props.userStore.entityReturn.notes.map(async (x: any) => {

      let url = await this.props.userStore.getCommentImage({ id: x.creatorID });
      this.props.userStore.entityNotesSummary.items.push({ ...x, profileImageURL: url });

      this.setState({ commentsLoading: true });
      this.setState({ defaultCommentsList: [] });
      let commentValues = this.props.userStore.entityNotesSummary.items;
      this.setState({ defaultCommentsList: commentValues });
      if (commentValues.length === noteCount) {
        this.setState({ commentsLoading: false });
      }
    })
  }

  async commentDelete(id: number) {
    this.setState({ commentsLoading: true });
    await this.props.userStore.removeNote(id);
    await this.commentFilter(this.state.commentsFilterValue);
    this.setState({ commentsLoading: false });
  }

  async commentFilter(id: any) {


    this.setState({ commentsLoading: true, commentsFilterValue: id });
    this.setState({ defaultCommentsList: [] });

    if (id === -1) {
      let filteredValues = this.props.userStore.entityNotesSummary.items;
      this.setState({ defaultCommentsList: filteredValues })
    }
    else {
      let filteredValues = this.props.userStore.entityNotesSummary.items.filter((x: any) => x.type === id);
      this.setState({ defaultCommentsList: filteredValues })
    }
    this.setState({ commentsLoading: false });
  }

  async commentSearch(filter: any) {
    this.setState({ commentsLoading: true });
    await this.commentFilter(this.state.commentsFilterValue);

    let valuesRetun: any[] = [];
    this.state.defaultCommentsList.map((x: any) => {
      if (x.body.toString().toLowerCase().includes(filter.toString().toLowerCase()) === true) { valuesRetun.push(x); }
    })

    this.setState({ defaultCommentsList: valuesRetun })
    this.setState({ commentsLoading: false });
  }

  //-----------------------------------------------------------------


  async getFileDownload(recordID: number) {

    let result = await this.props.userStore.getFileDownload(recordID);
    return result;
  }

  //-----------------------------------------------------------------

  async entityType_removeImage(file: UploadFile) {
    await this.props.userStore.removeFileFromList(file);
    return;
  }

  async entityType_removeFile(file: UploadFile) {
    await this.props.userStore.removeFileFromList(file);
    let removedItem = this.state.currentFileList.filter((x: UploadFile) => x.uid !== file.uid);
    this.setState({ currentFileList: removedItem });

    return;
  }


  async entityType_addFile(file: RcFile) {
    this.setState({ fileListLoading: true });
    let result = await this.props.userStore.uploadImage(file);

    let combinedItem = [result, ...this.state.currentFileList];
    this.setState({ currentFileList: combinedItem });

    return result.url;
  }


  //-----------------------------------------------------------

  entitytype_getProfileImage = async (recordID: number) => {
    let result = await this.getCurrentStore().getProfileImage(recordID);
    return result;
  }

  //-----------------------------------------------------------
  filter_Drawer = () => {
    this.setState({
      dashboardFilter_drawerVisible: !this.state.dashboardFilter_drawerVisible,
    });

  };

  help_Drawer = () => {
    this.setState({
      dashboardHelp_drawerVisible: !this.state.dashboardHelp_drawerVisible,
    });

  };

  signOut = () => {
    this.setState({
      signOut_drawerVisible: !this.state.signOut_drawerVisible,
    });
  };

  render() {

    const { profileID } = this.props;
    const currentStore = this.getCurrentStore();
    const { history } = this.props;

    const { currentRoles, isMobile } = this.props;

    const roles = currentRoles.map((x: string) => { var returnString = <div className="font-face-gm" style={{ float: 'left' }}>{x}</div>; return returnString; });

    //const roles = [L('Sales Lead')];

    return (
      <div style={{ background: '#f5f5f5' }}>

        <div style={{ background: '#f5f5f5' }}>


          {isMobile === false ?
            (

              <div>



                <div>

                  {this.props.headerLoading === true ?

                    (<Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} />) :

                    (<div><PageHeader
                      title={<div className="font-face-gm"><div
                        style={{ marginBottom: '0px', textAlign: 'left', fontSize: '1.5em', background: 'transparent' }}>{'Company Global'}</div>
                        <div style={{ marginTop: '-5px', opacity: '0.5', fontSize: '0.9em' }}>{this.props.currentName}</div></div>}

                      style={{ textAlign: 'left', marginBottom: '0px', marginTop: '15px' }}
                      tags={[
                        <div className="font-face-gm">
                          {roles}
                        </div>
                      ]}
                      avatar={{ size: 'large', src: CondoLogo }}
                    />




                    </div>)}

                  <div>

                    {this.state.softMenu === true ?
                      (<div><div style={{ float: 'right', position: 'fixed', top: 0, right: 25, zIndex: 100, }}>
                        <Dropdown className="font-face-gm" trigger={['click']}
                          overlay={
                            <Menu className="font-face-gm">



                            {this.state.enableActivity === true ?
                              <Menu.Item disabled={false} icon={<CommentOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.dashboard_OpenDrawer()}
                              >
                                {L('Activity')}
                              </Menu.Item>
                              : null}
                            {this.state.enableCalendar === true ?
                              <Menu.Item disabled={false} icon={<CalendarOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.calendar_OpenDrawer()}
                              >
                                {L('Calendar')}
                              </Menu.Item>
                              : null}
                            {this.state.enableFiles === true ?
                              <Menu.Item disabled={false} icon={<FolderOpenOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.calendar_OpenDrawer()}
                              >
                                {L('Files')}
                              </Menu.Item>
                              : null}
                            {this.state.enableOptions === true ?
                              <Menu.Item disabled={false} icon={<SettingOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.options_OpenDrawer()}
                              >
                                {L('Options')}
                              </Menu.Item>
                              : null}
                            {this.state.enableSearch === true ?
                              <Menu.Item disabled={false}  icon={<SearchOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                {L('Search')}
                              </Menu.Item>
                              : null}

                            <Divider style={{ margin: '0px' }} />

                            {this.state.enableSignOut === true ?
                              <Menu.Item
                                onClick={() => this.signOut()}
                                icon={<LogoutOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                {L('Sign Out')}
                              </Menu.Item>
                              : null}



                          </Menu>
                          } placement="bottomLeft"  >

                          <Button disabled={this.props.headerLoading} style={{
                            minWidth: '75px', minHeight: '35px', fontSize: '1.3em',
                            backgroundColor: 'transparent'
                          }} type="ghost">
                            {L('Menu')}
                          </Button>


                        </Dropdown>

                        <div style={{ float: 'right', position: 'fixed', top: 35, right: 25, zIndex: 99, }}>

                          <Button disabled={this.props.headerLoading} className="font-face-gm" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                            style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                            type="default">
                            <UpCircleOutlined />{L('Top')}
                          </Button>

                        </div>

                      </div>

                      </div>) :


                      <div><div style={{ float: 'right', position: 'fixed', top: 0, right: 25, zIndex: 99, }}>
                        <Dropdown className="font-face-gm"
                          trigger={['click']}
                          overlay={
                            <Menu className="font-face-gm">



                            {this.state.enableActivity === true ?
                              <Menu.Item disabled={false} icon={<CommentOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.dashboard_OpenDrawer()}
                              >
                                {L('Activity')}
                              </Menu.Item>
                              : null}
                            {this.state.enableCalendar === true ?
                              <Menu.Item disabled={false} icon={<CalendarOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.calendar_OpenDrawer()}
                              >
                                {L('Calendar')}
                              </Menu.Item>
                              : null}
                            {this.state.enableFiles === true ?
                              <Menu.Item disabled={false} icon={<FolderOpenOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.calendar_OpenDrawer()}
                              >
                                {L('Files')}
                              </Menu.Item>
                              : null}
                            {this.state.enableOptions === true ?
                              <Menu.Item disabled={false} icon={<SettingOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                onClick={() => this.options_OpenDrawer()}
                              >
                                {L('Options')}
                              </Menu.Item>
                              : null}
                            {this.state.enableSearch === true ?
                              <Menu.Item disabled={false}  icon={<SearchOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                {L('Search')}
                              </Menu.Item>
                              : null}

                            <Divider style={{ margin: '0px' }} />

                            {this.state.enableSignOut === true ?
                              <Menu.Item
                                onClick={() => this.signOut()}
                                icon={<LogoutOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                {L('Sign Out')}
                              </Menu.Item>
                              : null}



                          </Menu>
                          }

                          placement="bottomLeft"

                        >

                          <Button disabled={this.props.headerLoading} style={{
                            minWidth: '75px', minHeight: '35px', border: 'none', fontSize: '1.3em',
                            backgroundColor: this.props.primaryColor, color: 'white'
                          }} type="default">
                            {L('Menu')}
                          </Button>
                        </Dropdown>
                      </div>



                      </div>}

                  </div>

                </div>

              </div>
            ) : (

              <div>


                <div style={{ height: '22px' }}></div>
                {this.props.headerLoading === true ?

                  (<Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} />) :

                  (
                    <PageHeader
                      title={
                        <div className="font-face-gm"><div
                          style={{ marginBottom: '0px', textAlign: 'left', fontSize: '1em' }}>{'Company Global'}</div>
                          <div style={{ marginTop: '-15px', opacity: '0.5', fontSize: '0.7em' }}>{this.props.currentName}</div></div>}

                      style={{ textAlign: 'left', marginBottom: '0px', marginTop: '20px' }}
                      tags={[
                        <div className="font-face-gm">
                          {roles}
                        </div>
                      ]}


                      avatar={{ size: 'large', src: CondoLogo }}
                    />
                  )}


                <div>

                  {this.state.softMenu === true ?
                    (<div>
                      <div style={{
                        float: 'right', position: 'fixed',
                        top: 0, right: 25, zIndex: 99,
                      }}>
                        <Dropdown className="font-face-gm" trigger={['click']}
                          overlay={
                            <Menu className="font-face-gm">



                              {this.state.enableActivity === true ?
                                <Menu.Item disabled={false} icon={<CommentOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.dashboard_OpenDrawer()}
                                >
                                  {L('Activity')}
                                </Menu.Item>
                                : null}
                              {this.state.enableCalendar === true ?
                                <Menu.Item disabled={false} icon={<CalendarOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.calendar_OpenDrawer()}
                                >
                                  {L('Calendar')}
                                </Menu.Item>
                                : null}
                              {this.state.enableFiles === true ?
                                <Menu.Item disabled={false} icon={<FolderOpenOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.calendar_OpenDrawer()}
                                >
                                  {L('Files')}
                                </Menu.Item>
                                : null}
                              {this.state.enableOptions === true ?
                                <Menu.Item disabled={false} icon={<SettingOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.options_OpenDrawer()}
                                >
                                  {L('Options')}
                                </Menu.Item>
                                : null}
                              {this.state.enableSearch === true ?
                                <Menu.Item disabled={false}  icon={<SearchOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                  {L('Search')}
                                </Menu.Item>
                                : null}

                              <Divider style={{ margin: '0px' }} />

                              {this.state.enableSignOut === true ?
                                <Menu.Item
                                  onClick={() => this.signOut()}
                                  icon={<LogoutOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                  {L('Sign Out')}
                                </Menu.Item>
                                : null}



                            </Menu>
                          } placement="bottomLeft"  >

                          <Button disabled={this.props.headerLoading}
                            style={{
                              minWidth: '60px', minHeight: '30px', border: 'none', fontSize: '1.1em',
                              backgroundColor: 'transparent'
                            }} type="ghost">
                            {L('Menu')}
                          </Button>


                        </Dropdown>

                        <div style={{ float: 'right', position: 'fixed', top: 35, right: 25, zIndex: 99, }}>

                          <Button disabled={this.props.headerLoading} className="font-face-gm" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} size='small'
                            style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                            type="default">
                            <UpCircleOutlined />{L('Top')}
                          </Button>

                        </div>

                      </div>

                    </div>) :


                    <div>

                      <div style={{ float: 'right', position: 'fixed', top: 0, right: 25, zIndex: 99, }}>
                        <Dropdown className="font-face-gm"
                          trigger={['click']}
                          overlay={
                            <Menu className="font-face-gm">



                              {this.state.enableActivity === true ?
                                <Menu.Item disabled={false} icon={<CommentOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.dashboard_OpenDrawer()}
                                >
                                  {L('Activity')}
                                </Menu.Item>
                                : null}
                              {this.state.enableCalendar === true ?
                                <Menu.Item disabled={false} icon={<CalendarOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.calendar_OpenDrawer()}
                                >
                                  {L('Calendar')}
                                </Menu.Item>
                                : null}
                              {this.state.enableFiles === true ?
                                <Menu.Item disabled={false} icon={<FolderOpenOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.calendar_OpenDrawer()}
                                >
                                  {L('Files')}
                                </Menu.Item>
                                : null}
                              {this.state.enableOptions === true ?
                                <Menu.Item disabled={false} icon={<SettingOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                  onClick={() => this.options_OpenDrawer()}
                                >
                                  {L('Options')}
                                </Menu.Item>
                                : null}
                              {this.state.enableSearch === true ?
                                <Menu.Item disabled={false}  icon={<SearchOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                  {L('Search')}
                                </Menu.Item>
                                : null}

                              <Divider style={{ margin: '0px' }} />

                              {this.state.enableSignOut === true ?
                                <Menu.Item
                                  onClick={() => this.signOut()}
                                  icon={<LogoutOutlined  style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />} >
                                  {L('Sign Out')}
                                </Menu.Item>
                                : null}



                            </Menu>
                          }

                          placement="bottomLeft"

                        >

                          <Button size='small' disabled={this.props.headerLoading} style={{
                            minWidth: '60px', minHeight: '30px', border: 'none', fontSize: '1.1em',
                            backgroundColor: this.props.primaryColor, color: 'white'
                          }} type="default">
                            {L('Menu')}
                          </Button>
                        </Dropdown>
                      </div>

                    

                      <div style={{  float: 'right', position: 'fixed', top: 35, right: 25, zIndex: 99, }}>
                        <Dropdown className="font-face-gm"  
                          trigger={['click']}
                          overlay={
                            <Menu className="font-face-gm" style={{fontSize: '0.8em'}}  >


                              {appRouters
                                .filter((item: any) => !item.isLayout && item.showInMenu)
                                .map((route: any, index: number) => {
                                  if (route.permission && !isGranted(route.permission)) return null;

                                  return (
                                    <Menu.Item key={route.path}
                                      onClick={() => history.push(route.path)}>
                                      <div style={{float: 'left', marginRight: '10px'}}>
                                        {
                                          route.icon === 'dashboard' ? (<DashboardOutlined style={{ fontSize: this.state.iconFontSize, }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                            : route.icon === 'people' ? (<ShopOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                              : route.icon === 'teams' ? (<DeploymentUnitOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                : route.icon === 'inventory' ? (<GroupOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                  : route.icon === 'workOrder' ? (<ShoppingCartOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                    : route.icon === 'scheduling' ? (<TeamOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                      : route.icon === 'message' ? (<CommentOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                        : route.icon === 'reports' ? (<ShoppingOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                          : route.icon === 'integrations' ? (<ApiTwoTone style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                            : route.icon === 'payments' ? (<HistoryOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                              : route.icon === 'layout' ? (<AuditOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                : route.icon === 'user' ? (<IdcardOutlined style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                  : route.icon === 'role' ? (<LockTwoTone style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                    : route.icon === 'tenant' ? (<AppstoreTwoTone style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                      : route.icon === 'infoHub' ? (<FileTextTwoTone style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                        : <RightCircleTwoTone style={{ fontSize: this.state.iconFontSize,  }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}

                                      </div>
                                      <span >{L(route.title)}</span>
                                    </Menu.Item>
                                  );
                                })}



                            </Menu>
                          }

                          placement="bottomLeft"

                        >

                          <Button disabled={this.props.headerLoading} size='small' style={{
                           minWidth: '60px', minHeight: '30px', border: 'none', fontSize: '1.1em',
                            backgroundColor: 'transparent', color: this.props.primaryColor
                          }} type="default">
                            {L('Nav')}
                          </Button>
                        </Dropdown>
                      </div>

               


                    </div>}

                </div>


              </div>
            )}

        </div>


        <Dashboard
          getUserProfileImage={(e: any) => this.props.userStore.getProfileImage(e)}
          intialFilesList={[]}
          fileList={this.state.currentFileList}
          removeFile={(e) => this.entityType_removeFile(e)}
          addFile={(e) => this.entityType_addFile(e)}
          getFile={(e) => this.getFileDownload(e)}
          filesLoading={this.state.filesLoading}
          currentNotifications={this.props.userStore.currentNotifications}
          defaultType={this.state.commentsFilterValue}
          visible={this.state.dashboard_drawerVisible}
          onCancel={this.dashboard_handleCancel}
          currentProfileImage={this.state.currentProfileImage}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          currentState={this.state.currentState}
          commentFilter={(e) => this.commentFilter(e)}
          commentSearch={(e) => this.commentSearch(e)}
          currentUserID={this.props.userID}
          currentUserName={this.props.currentName}
          commentDataSummary={this.state.defaultCommentsList}
          defaultIcon={<IdcardTwoTone twoToneColor={this.props.secondaryColor} style={{ fontSize: 50, padding: '5px' }} />}
          commentsLoading={this.state.commentsLoading}
          defaultImage={this.state.defaultProfileImage}
          title={this.props.currentLoginName + '\'s'}
          subTitle={this.state.lastModifiedClean}
          search_Hashtags={this.state.availableItemsList}
          search_Mentions={this.props.userStore.search_Mentions}
          commentAdd={(e: any) => this.commentAdd(e)}
          commentDelete={(e: any) => this.commentDelete(e)}
        />

        <Options
          subscriptionType={this.props.subscriptionType}
          subscriptionStart={this.props.subscriptionStart}
          subscriptionEnd={this.props.subscriptionEnd}
          availableTemplates={this.props.availableTemplates}
          firstName={'Benjamin Allen'}
          lastName={this.props.userLastName}
          email={this.props.userEmail}
          userStore={this.props.userStore}
          formRef={this.userEdit_FormRef}
          profileImageID={profileID}
          isMobile={isMobile}
          visible={this.state.options_drawerVisible}
          loading={this.state.loading}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          defaultImage={this.state.defaultProfileImage}
          onCreate={this.options_handleUpdate}
          onCancel={this.options_handleCancel}
          uploadProfileImage={this.options_uploadImage}
        />

        <TimeClock
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          visible={this.state.timeClock_drawerVisible}
          onCancel={() =>
            this.setState({
              timeClock_drawerVisible: false,
            })
          }
        />



        <CalendarForm
          isMobile={isMobile}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          loading={this.state.loading}
          visible={this.state.calendar_modalVisible}
          onCancel={() => this.setState({
            calendar_modalVisible: false,
          })}
        />

        <DashboardFilterDrawer
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          onCancel={() => this.setState({ dashboardFilter_drawerVisible: false })}
          visible={this.state.dashboardFilter_drawerVisible} />

        <DashboardHelp
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          onCancel={() => this.setState({ dashboardHelp_drawerVisible: false })}
          visible={this.state.dashboardHelp_drawerVisible} />

        <SignOutDrawer
          isMobile={isMobile}
          location={this.props.location}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          onCancel={() => this.setState({ signOut_drawerVisible: false })}
          visible={this.state.signOut_drawerVisible} />



        <ModuleChooser
          loading={this.state.loading}
          isMobile={isMobile}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          dataTableImage={''}
          dataTableText={''}
          search_Mentions={this.props.userStore.search_Mentions}
          search_Hashtags={[]}
          visible={this.state.createItem_modalVisible}
          handleSearch={(e) => ''}
          onCreate={(e) => this.createItem_handleUpdate(e)}
          onCancel={this.createItem_handleCancel}


        />

        <TemplateChooser
          getProfileImage={(e) => this.entitytype_getProfileImage(e)}
          loading={this.state.loading}
          isMobile={isMobile}
          entityStore={currentStore}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          dataTableImage={''}
          dataTableText={''}
          search_Mentions={this.props.userStore.search_Mentions}
          search_Hashtags={[]}
          visible={this.state.templateChooser_modalVisible}
          handleSearch={(e) => ''}
          onCreate={(e) => this.entity_create(e)}
          onCancel={this.templateSelect_handleCancel}
        />




      </div >
    );
  }
}

export default Header;
